import { CountryCode } from '@client/constants';
import { useApiClient } from '@client/hooks/useApiClient';
import { useImageUpload } from '@client/hooks/useImageUpload';
import { callApi } from '@client/utils/apiUtils';
import { shopProfileImageUrl } from '@client/utils/imageUtils';
import { ImageUploadKind } from '@heirloom/common/constants';
import { ValidationField } from '@heirloom/common/validation/shared';
import { validateShopFields } from '@heirloom/common/validation/shop';
import { useRef, useState } from 'react';
export const useShopForm = ({ initialData, } = {}) => {
    const apiClient = useApiClient();
    const [title, setTitle] = useState(initialData?.title ?? '');
    const [classification, setClassification] = useState(initialData?.classification ?? '');
    const [country, setCountry] = useState(initialData?.countryCode ?? CountryCode.US);
    const [location, setLocation] = useState(initialData?.location ?? '');
    const [titleError, setTitleError] = useState(null);
    const [classificationError, setClassificationError] = useState(null);
    const [locationError, setLocationError] = useState(null);
    // The existing server-side image, shown as the initial preview and
    // used as the fallback uuid if no new image has been uploaded
    const existingImageUuid = useRef(initialData?.profileImageUuid ?? null);
    const existingPreviewUrl = initialData?.profileImageUuid
        ? shopProfileImageUrl(initialData.profileImageUuid)
        : null;
    const { imageEntries, addFiles, isUploading, uuids } = useImageUpload(async (contentType) => {
        const result = await callApi(apiClient.admin.getShopImageUploadUrl({
            body: { contentType },
        }));
        return result.error !== null ? null : result.data;
    }, ImageUploadKind.SHOP);
    const imagePreviewUrl = imageEntries[0]?.previewUrl ?? existingPreviewUrl;
    const isUploadingImage = isUploading;
    const handleImageSelect = (file) => addFiles([file]);
    const resolveImageUuid = () => uuids[0] ?? existingImageUuid.current ?? undefined;
    const validateSharedFields = () => {
        const errors = validateShopFields({
            title,
            classification,
            location,
        });
        setTitleError(errors.find((e) => e.field === ValidationField.Title)
            ?.message ?? null);
        setClassificationError(errors.find((e) => e.field === ValidationField.Classification)?.message ?? null);
        setLocationError(errors.find((e) => e.field === ValidationField.Location)
            ?.message ?? null);
        return errors.length === 0;
    };
    return {
        title,
        setTitle,
        classification,
        setClassification,
        country,
        setCountry,
        location,
        setLocation,
        imagePreviewUrl,
        isUploadingImage,
        handleImageSelect,
        resolveImageUuid,
        titleError,
        setTitleError,
        classificationError,
        locationError,
        validateSharedFields,
    };
};
